import {
  Button,
  ComponentStyle,
  Form,
  Formik,
  FormikControl,
  useState,
  useRouter,
  CustomCompanyIntegrationModalAction,
  CONSTANTS,
  InputError,
  useRef,
} from "@/imports-files/components/model/custom-company-integration-modal";
import { FormModalStyle } from "@/imports-files/components/review-email";
import Modal from "../common-modal/modal";

export function CustomCompanyIntegrationModal(props) {
  const router = useRouter();
  const [categoryList, setCategoryList] = useState([props.categories]);
  const formRef = useRef(null);
  const custom_company_integration_modal_action =
    new CustomCompanyIntegrationModalAction(
      props.setModal,
      props.setCustomEnableItems,
      props.setFlagForRerender,
      props.setApiError,
      formRef
    );
  const operation_type = props.data ? "Edit" : "Create";

  return (
    <Modal
      type="form"
      heading="Add Integration"
      closeModal={() => {
        custom_company_integration_modal_action.resetForm(formRef);
        props.setModal(false);
      }}
      content={
        <Formik
          enableReinitialize
          initialValues={custom_company_integration_modal_action.setInitialValues(
            props.data,
            operation_type
          )}
          validationSchema={CONSTANTS.formValidations}
          innerRef={formRef}
          onSubmit={(values) => {
            custom_company_integration_modal_action.submitForm(
              values,
              operation_type
            );
          }}
        >
          {(formik) => (
            <Form>
              <div
                className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
              >
                <label
                  className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                >
                  Domain *
                </label>
                <FormikControl
                  control="input"
                  name="custom_integration.domain"
                  className={`${ComponentStyle.Form__Input}`}
                  style={InputError(formik, "custom_integration.domain")}
                  formik={formik}
                  onKeyDown={(event) => {
                    formik.setStatus("custom_integration.domain", "");
                  }}
                />
              </div>
              <div
                className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
              >
                <label
                  className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                >
                  Name *
                </label>
                <FormikControl
                  control="input"
                  name="custom_integration.name"
                  className={`${ComponentStyle.Form__Input}`}
                  style={InputError(formik, "custom_integration.name")}
                  formik={formik}
                />
              </div>
              <div
                className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
              >
                <label
                  className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                >
                  Category
                </label>
                <FormikControl
                  className={`${ComponentStyle.Form__Input} JobCustomSelect`}
                  control="select"
                  name="custom_integration.category"
                  default={formik?.values?.custom_integration?.category || ""}
                  onChange={(option) => {
                    formik.setFieldValue(
                      "custom_integration.category",
                      option.value
                    );
                  }}
                  options={custom_company_integration_modal_action.getSelectValue(
                    categoryList[0]
                  )}
                  formik={formik}
                  style={InputError(formik, "custom_integration.category")}
                />
              </div>
              <div className={FormModalStyle.Modal__Container__ButtonSection}>
                <Button buttonstyle={ComponentStyle.primarybtn} type="submit">
                  Save
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      }
    />
  );
}
